import $ from 'jquery';
import axios from "axios";

export const downloadHandlers = () => {
    $('#notes-button').click(function () {
        $('.modal#version .modal-header__title').text($(this).parent().find('.main-download__info-version').text());
        $('.modal#version .modal-body__version-content').html($(this).data('notes'));
    });

    $('.versions__notes > #notes-button').click(function () {
        $('.modal#version .modal-header__title').text($(this).parents('.versions__top').find('.versions__name').text());
        $('.modal#version .modal-body__version-content').html($(this).data('notes'));
    });

    $('.download-button').click(function () {
        if ($(this).data('redirect') !== undefined) {
            $('.modal#before-download').hide();
            window.location.href = $(this).data('redirect');

            return;
        }

        if ($(this).parent().is('.main-download__button')) {
            $('.modal#before-download .modal-header__title').text($(this).parents('.main-download').find('.main-download__info-version').text());

        } else {
            $('.modal#before-download .modal-header__title').text($(this).parents('.versions__top').find('.versions__name').text());
        }

        $('.modal#before-download .button-accept').data('url', $(this).data('url'));
        $('.modal#before-download .button-accept').data('platform', $(this).data('platform'));
        $('.modal#before-download .button-accept').data('buildId', $(this).data('buildId'))
    });
    $('#after-download').on('hidden.bs.modal', function (e) {
        $('body').css('overflow-y', 'auto');
    });

    $('.button-accept').click(function () {
        $('.modal#before-download .close').click();
        $('body').css('overflow-y', 'hidden');

        axios.post($(this).data('ajaxUrl'), {buildId: $(this).data('buildId'), platform: $(this).data('platform')})
            .then((response) => {
            });
        window.location = $(this).data('url');
        $('#after-download').modal('show');
        $('#modal-backdrop').addClass('data-modal-color');
        $('body').addClass('modal-open');
    });

    $('.button-dont-accept').click(function () {
        $('.modal#before-download .close').click();
    });
};
